function displayScreen() {

}